import { Link, useLocation } from "react-router-dom"
import { founderCourseUnsubscribePath, newsletterUnsubscribePath, rootPath } from "~/common/paths"
import { buttonVariants } from "~/ui/button"

export const NewsletterUnsubscribePage = ({
  email,
  unsubscribed,
  course = false,
}: {
  email?: string
  unsubscribed: boolean
  course?: boolean
}) => {
  const { search } = useLocation()
  const token = new URLSearchParams(search).get("token")

  return (
    <section className="bg-background px-4 py-20 text-center sm:px-6 sm:py-28">
      <div className="mx-auto max-w-xl">
        {unsubscribed ? (
          <>
            <h1 className="home-sans-heading text-4xl font-semibold text-foreground sm:text-5xl">
              You&apos;re unsubscribed
            </h1>
            <p className="mt-5 text-lg text-muted-foreground">
              You will no longer receive Tanooki Labs emails.
            </p>
            <div className="mt-8 flex flex-wrap justify-center gap-4">
              <Link to={rootPath({})} className={buttonVariants({})}>
                Back home
              </Link>
              <a
                href="mailto:contact@tanookilabs.com?subject=Resubscribe%20to%20Tanooki%20Labs%20emails"
                className={buttonVariants({ variant: "outline" })}
              >
                Resubscribe
              </a>
            </div>
          </>
        ) : (
          <>
            <h1 className="home-sans-heading text-4xl font-semibold text-foreground sm:text-5xl">
              Unsubscribe {email} from Tanooki Labs emails?
            </h1>
            <p className="mt-5 text-lg text-muted-foreground">
              We&apos;ll stop sending {course ? "this course" : "newsletters"} to this address.
            </p>
            <form
              method="post"
              action={course ? founderCourseUnsubscribePath({}) : newsletterUnsubscribePath({})}
              className="mt-8"
            >
              <input type="hidden" name="token" value={token || ""} />
              <button type="submit" className={buttonVariants({})}>
                Confirm unsubscribe
              </button>
            </form>
          </>
        )}
      </div>
    </section>
  )
}
